import { CSSProperties } from 'react';
import { Container, Title, Description } from './styled';

interface EmptyMessageProps {
    style?: CSSProperties;
    className?: string;
    title?: string | React.ReactNode;
    description?: string | React.ReactNode;
    action?: React.ReactNode;
    icon?: React.ReactNode;
}

const EmptyMessage = (props: EmptyMessageProps) => {
    const { icon, title, description, action, className, style } = props;

    return (
        <Container className={className} style={style}>
            {icon}
            <Title>{title}</Title>
            <Description>{description}</Description>
            {action}
        </Container>
    );
};

export default EmptyMessage;
